export default __webpack_public_path__ + "static/media/logo-android.9c9aa1f1.svg";